import React from "react";
import PropTypes from "prop-types";
import { Field, Control, Label, Input } from "rbx";
import { DateInput, CurrencyInput, EmployeeSelect } from "../inputs";

function VehicleELDForm({ inputs, onChange }) {
  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <Label>Date</Label>
          <DateInput
            name="ELDDate"
            type="date"
            value={inputs.ELDDate}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <EmployeeSelect
            icon="user"
            label="Driver"
            name="DriverRecIdRef"
            value={inputs?.DriverRecIdRef}
            variables={{
              where: { DriverFlag: true },
              orderByMulti: ["LastName_ASC"]
            }}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>State</Label>
          <Input
            name="State"
            type="text"
            value={inputs.State}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Odometer Reading</Label>
          <Input
            autoComplete="new"
            name="OdometerReading"
            type="text"
            value={inputs.OdometerReading}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>Miles Used</Label>
          <Input
            autoComplete="new"
            name="MilesUsed"
            type="text"
            value={inputs.MilesUsed}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Cost</Label>
          <CurrencyInput
            name="Cost"
            type="text"
            value={inputs.Cost}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Qty</Label>
          <Input
            autoComplete="new"
            name="Qty"
            type="text"
            value={inputs.Qty}
            onChange={onChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}

VehicleELDForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
VehicleELDForm.defaultProps = {
  inputs: {}
};
export default VehicleELDForm;
